import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Badge } from "@/components/ui/badge";

export function ItineraryTimeline({ itinerary }) {
  if (!itinerary || itinerary.length === 0) {
    return <p className="text-sm text-slate-500">Itinerary details will be shared upon enquiry.</p>;
  }

  return (
    <Accordion type="single" collapsible defaultValue="day-1" data-testid="itinerary-accordion" className="timeline-line pl-2">
      {itinerary.map((day) => (
        <AccordionItem
          key={day.day_number}
          value={`day-${day.day_number}`}
          data-testid="itinerary-day-item"
          className="relative border-b-0 pb-2 pl-8"
        >
          <span className="absolute left-[9px] top-3.5 h-3 w-3 -translate-x-1/2 rounded-full border-2 border-white bg-[hsl(var(--brand-primary))]" />
          <AccordionTrigger className="rounded-lg py-3 hover:no-underline [&>svg]:shrink-0">
            <div className="flex flex-wrap items-center gap-2 text-left">
              <Badge className="bg-[hsl(var(--brand-primary))] text-white hover:bg-[hsl(var(--brand-primary))]">Day {day.day_number}</Badge>
              <span className="font-display text-sm font-semibold text-slate-900 sm:text-base">{day.day_title}</span>
            </div>
          </AccordionTrigger>
          <AccordionContent>
            <p className="text-sm leading-relaxed text-slate-600">{day.description}</p>
            {day.inclusions?.length > 0 && (
              <div className="mt-2 flex flex-wrap gap-1.5">
                {day.inclusions.map((inc, i) => (
                  <Badge key={i} variant="outline" className="border-slate-200 text-xs text-slate-500">
                    {inc}
                  </Badge>
                ))}
              </div>
            )}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
}
